export default __webpack_public_path__ + "static/media/btn-lpmall-view-pin-on.7e58d98e.svg";